import {
  getOrCheckSurveySchemaCode,
  postSurveySchema,
  putSurveySchema,
  patchSurveySchemaFeedbackIntroduction,
  postSchemaVersion
} from '../api';

export const CLEAR_SURVEY_SCHEMA_OPTIONS = 'CLEAR_SURVEY_SCHEMA_OPTIONS';
export const GET_OR_CHECK_SURVEY_SCHEMA_CODE = 'GET_OR_CHECK_SURVEY_SCHEMA_CODE';
export const POST_SURVEY_SCHEMA = 'POST_SURVEY_SCHEMA';
export const POST_NEW_SURVEY_SCHEMA_VERSION = 'POST_NEW_SURVEY_SCHEMA_VERSION';
export const PUT_SURVEY_SCHEMA = 'PUT_SURVEY_SCHEMA';
export const UPDATE_SURVEY_SCHEMA_FEEDBACK_INTRODUCTION = 'UPDATE_SURVEY_SCHEMA_FEEDBACK_INTRODUCTION';
export const UPDATE_SURVEY_SCHEMA_OPTIONS = 'UPDATE_SURVEY_SCHEMA_OPTIONS';
export const UPDATE_SURVEY_SCHEMA_PARTS = 'UPDATE_SURVEY_SCHEMA_PARTS';

export const clearSurveySchemaOptionsAction = () => ({
  type: CLEAR_SURVEY_SCHEMA_OPTIONS
});

export const getOrCheckSurveySchemaCodeAction = (code) => ({
  type: GET_OR_CHECK_SURVEY_SCHEMA_CODE,
  payload: getOrCheckSurveySchemaCode(code)
});

export const postSurveySchemaAction = (surveySchemaOptions) => ({
  type: POST_SURVEY_SCHEMA,
  payload: postSurveySchema(surveySchemaOptions)
});

export const postNewSurveySchemaVersionAction = (schemaId, surveySchemaOptions) => ({
  type: POST_NEW_SURVEY_SCHEMA_VERSION,
  payload: postSchemaVersion(schemaId, surveySchemaOptions)
});

export const putSurveySchemaAction = (schemaId, options) => ({
  type: PUT_SURVEY_SCHEMA,
  payload: putSurveySchema(schemaId, options)
});

export const updateSurveySchemaFeedbackIntroduction = (schemaId, data) => ({
  type: UPDATE_SURVEY_SCHEMA_FEEDBACK_INTRODUCTION,
  payload: patchSurveySchemaFeedbackIntroduction(schemaId, data)
});

export const updateSurveySchemaOptionsAction = (surveySchemaOptions) => ({
  type: UPDATE_SURVEY_SCHEMA_OPTIONS,
  payload: surveySchemaOptions
});

export const updateSurveySchemaPartsAction = (surveySchemaParts) => ({
  type: UPDATE_SURVEY_SCHEMA_PARTS,
  payload: surveySchemaParts
});
